import { jumpWebView } from './common'
/**
 * 分享页面 课件跳转
 * caseaddress: 项目地址；
 * urlParams：url参数
 */
export function jumpPageUrl(caseaddress = '', urlParams = '', type = false) {
  if (!caseaddress) return
  const url = basePageUrl(caseaddress) + urlParams
  if (type) {
    jumpWebView.openNewWinWithNavigator(url)
  } else {
    jumpWebView.openNewWinWithoutNavigator(url)
  }
}

export function jumpPageUrlWeb(caseaddress = '', urlParams = '', type = false) {
  if (!caseaddress) return
  const url = basePageUrlWeb(caseaddress) + urlParams
  if (type) {
    jumpWebView.openNewWinWithNavigator(url)
  } else {
    jumpWebView.openNewWinWithoutNavigator(url)
  }
}

export function basePageUrlWeb(type) {
  const env =
    location.href.indexOf('-110') > -1
      ? '110'
      : location.href.indexOf('/debug-') > -1 ||
        location.href.indexOf('localhost') > -1 ||
        location.href.indexOf('192.168.') > -1
      ? 'debug'
      : 'pro'

  const page = {
    primary: {
      debug: `${location.origin}/113-service/debug-8080/xxxx-web/yunjiaotingshuo/studentsite-web/index.html`,
      110: `${location.origin}/113-service/debug-8080/xxxx-web-110/yunjiaotingshuo/studentsite-web/index.html`,
      pro: `${location.origin}/studentsite-web/index.html`
    },
    vant: {
      debug: `${location.origin}/113-service/debug-8080/xxxx-web/yunjiaotingshuo/vant`,
      110: `${location.origin}/113-service/debug-8080/xxxx-web-110/yunjiaotingshuo/vant`,
      pro: `${location.origin}/vant`
    }
  }
  return page[type][env]
}

function basePageUrl(type) {
  const env =
    location.href.indexOf('-110') > -1
      ? '110'
      : location.href.indexOf('/debug-') > -1 ||
        location.href.indexOf('localhost') > -1 ||
        location.href.indexOf('192.168.') > -1
      ? 'debug'
      : 'pro'
  const page = {
    primary: {
      110: '//222.212.88.30:8113/debug-8080/xxxx-web-110/app/views/',
      debug: '//222.212.88.30:8113/debug-8080/xxxx-web/app/views/',
      pro: '//student-primary.zhihuiliu.com/app/views/'
    },
    pk: {
      110: '//zhl-test.xxfz.com.cn/113-service/debug-8080/xxxx-web-110/app/activity/',
      // 110: 'http://222.212.88.30:8113/debug-8080/xxxx-web-110/app/activity/',
      // debug: 'http://192.168.2.5:8098/',
      // debug: 'http://222.212.88.30:8113/debug-8080/xxxx-web/app/activity/',
      debug:
        '//zhl-test.xxfz.com.cn/113-service/debug-8080/xxxx-web/app/activity/',
      pro: '//student-primary.zhihuiliu.com/app/activity/'
    },
    xiamenyizhong: {
      110: '//zhl-test.xxfz.com.cn/113-service/debug-8080/xxxx-web-110/app/activity/',
      // 110: 'http://222.212.88.30:8113/debug-8080/xxxx-web-110/app/activity/',
      // debug: 'http://192.168.2.5:8098/',
      // debug: 'http://222.212.88.30:8113/debug-8080/xxxx-web/app/activity/',
      debug:
        '//zhl-test.xxfz.com.cn/113-service/debug-8080/xxxx-web/app/activity/',
      pro: '//xiamenyizhong.qujiao.com/app/activity/'
    },
    vant: {
      110: '//222.212.88.30:8113/debug-8080/qiaokao-web/views/pages/new/',
      debug:
        '//222.212.88.30:8113/debug-8080/qiaokao-web-test/views/pages/new/',
      pro: '//student-primary.zhihuiliu.com/app/do-exercise/views/pages/new/'
    },
    // 课件
    smartcourseware: {
      110: '//222.212.88.30:8113/debug-8080/xxxx-web-110/smartcourseware/index.html',
      debug:
        '//222.212.88.30:8113/debug-8080/xxxx-web/smartcourseware/index.html',
      pro: '//s.qujiao.com'
    },
    // 支付
    paycenter: {
      110: '//222.212.88.30:8113/debug-8080/xxxx-web-110/app/paycenter/views/payment/',
      debug:
        '//222.212.88.30:8113/debug-8080/xxxx-web/app/paycenter/views/payment/',
      pro: '//student-primary.zhihuiliu.com/app/paycenter/views/payment/'
    },
    // （开通会员用新地址）
    newpaycenter: {
      110: '//222.212.88.30:8113/debug-8080/xxxx-web-110/app/newpaycenter/views/payment/',
      debug:
        '//222.212.88.30:8113/debug-8080/xxxx-web/app/newpaycenter/views/payment/',
      pro: '//student-primary.zhihuiliu.com/app/newpaycenter/views/payment/'
    }
  }
  return page[type][env]
}

/**
 * 对象转为url参数
 */
export function httpBuilderUrl(data) {
  let url = ''
  if (
    typeof data === 'undefined' ||
    data === null ||
    typeof data !== 'object'
  ) {
    return ''
  }
  url += url.indexOf('?') !== -1 ? '' : '?'
  for (var k in data) {
    url +=
      (url.indexOf('=') !== -1 ? '&' : '') +
      k +
      '=' +
      encodeURIComponent(data[k])
  }
  return url
}
/**
 * @description 设置缓存
 * @param {*} key 缓存key
 * @param {*} valye 缓存的值
 */
export function setCache(key, value) {
  //  TODO 统一管理缓存
  localStorage.setItem(key, JSON.stringify(value))
}
/**
 * @description  获取缓存
 * @param {*} key
 * @returns cacheInfo
 */
export function getCache(key) {
  const cacheInfo = localStorage.getItem(key)
  try {
    if (cacheInfo) {
      if (['null', 'undefined'].includes(cacheInfo)) return null
      return JSON.parse(cacheInfo)
    } else {
      return null
    }
  } catch (error) {
    return null
  }
}
